import audioIcon from "../assets/icon/audioIcon.svg";
import hearRead from "../assets/icon/hearRead.svg";
import listen from "../assets/icon/listen.png";
import readIcon from "../assets/icon/readIcon.svg";
import speak from "../assets/icon/speak.svg";
import submitIcon from "../assets/icon/submitIcon.svg";
import tapIcon from "../assets/icon/tapIcon.svg";
import typingIcon from "../assets/icon/typingIcon.svg";
import { HelperContext } from "../store/helperStore";

const nonAudioInst = [
    { img: readIcon, title: "Read" },
    { img: typingIcon, title: "Type to answer" },
    { img: submitIcon, title: "Submit" },
];


const audioInst = [
    { img: hearRead, title: "Listen/Read" },
    { img: audioIcon, title: "Press to start" },
    { img: speak, title: "Speak" },
    { img: audioIcon, title: "Press to stop" },
];

const wordSound = [
    { img: hearRead, title: "Listen/Read" },
    { img: audioIcon, title: "Press to start" },
    { img: speak, title: "Speak" },
    { img: audioIcon, title: "Press to stop" },
];

const speedImgRecallInst = [
    { img: readIcon, title: "View" },
    { img: audioIcon, title: "Press to start" },
    { img: speak, title: "Speak" },
    { img: audioIcon, title: "Press to stop" },
];

const soundDiffInst = [
    { img: listen, title: "Listen" },
    { img: tapIcon, title: "Tap to answer" },
    { img: submitIcon, title: "Submit" },
];

const dualNBack1 = [
    { img: hearRead, title: "Listen/Read" },
    { img: tapIcon, title: "Tap to answer" },
    { img: submitIcon, title: "Submit" },
];

const CPT = [
    { img: readIcon, title: "View" },
    { img: tapIcon, title: "Tap to answer" },
    { img: submitIcon, title: "Submit" },
];

const multiTap = [
    { img: readIcon, title: "View" },
    { img: tapIcon, title: "Tap to answer" },
    { img: submitIcon, title: "Submit" },
];
const FNMix = [
    { img: readIcon, title: "View/Read" },
    { img: tapIcon, title: "Tap to answer" },
    { img: submitIcon, title: "Submit" },
];

export function getTestInst(questions) {
    const { helperC } = HelperContext();

    console.log(questions, 'test--');

    if (questions.test_format === "listen_speak_series") {
        return speedImgRecallInst;
    } else if (questions.test_format === "listen_sound_differ") {
        return soundDiffInst;
    } else if (
        questions.section_name === "CONTINUOUS PERFORMANCE" ||
        questions.section_name === "CHOICE REACTION" ||
        questions.section_name === "SIMPLE REACTION"
    ) {
        return CPT;
    } else if (questions.test_format === "tap_nback1") {
        return dualNBack1;
    } else if (questions.section_name === "TEXT MATCHING" || questions.test_format === "digit_span") {
        return FNMix;
    } else if (questions.test_format === "single_tap_two" || questions.test_format === "single_tap" || questions.test_format === "multi_tap") {
        return multiTap;
    } else if (questions.test_format === "visual_facename_mix") {
        return FNMix;
    }

    // audio instruction
    else if (
        questions.test_format === "listen_speak_soundlist" ||
        questions.test_format === "listen_speak" ||
        questions.test_format === "listen_speak_sound" ||
        questions.test_format === "listen_speak_para" ||
        questions.test_format === "simple_reaction_sound" ||
        questions.test_format === "listen_speak_fluency"
    ) {
        return audioInst;
    }
    // non-audio instruction
    else if (
        questions.test_format === "visual_shuffle" ||
        questions.test_format === "multi_fill" ||
        questions.test_format === "visual_keypad" ||
        questions.test_format === "simple_reaction" ||
        questions.test_format === "choice_reaction" ||
        questions.test_format === "tap_letter"
    ) {
        return nonAudioInst;
    }
    else if (helperC.isAudioTest) {
        return audioInst;
    } else if (!helperC.isAudioTest) {
        return nonAudioInst;
    }
}
